const ACTION_TYPES = {
  RECEIVED_CODENODE_DATA: 'RECEIVED_CODENODE_DATA',
  SET_CODENODE_COORDS: 'SET_CODENODE_COORDS',
  UPDATE_CODENODE_DATA: 'UPDATE_CODENODE_DATA',
  RESET_CODENODE_DATA: 'RESET_CODENODE_DATA',
  SAVE_CODENODE_DATA: 'SAVE_CODENODE_DATA',
  UPDATE_EDITOR_DATA: 'UPDATE_EDITOR_DATA',
  SET_ENV_VARIABLES: 'SET_ENV_VARIABLES',
  RESET_ENV_VARIABLES: 'RESET_ENV_VARIABLES',
};

export default ACTION_TYPES;
